import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconQuestionMarkCircleFull = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.926 1 1 5.925 1 12s4.926 11 11 11 11-4.925 11-11S18.074 1 12 1Zm-1.945 7.403C9.99 8.728 9.73 9 9.4 9h-.8c-.33 0-.604-.27-.56-.598C8.306 6.426 9.892 5 12 5c2.371 0 4 1.627 4 4 0 1.36-.848 2.38-1.684 3.386-.261.314-.521.626-.754.947q-.131.18-.25.365l-.062.1-.072.13a1.5 1.5 0 00-.168.455 1 1 0 00-.01.117.59.59 0 01-.59.59h-.82a.59.59 0 01-.59-.59c0-.726.3-1.362.625-1.873a5 5 0 01.414-.546c.15-.177.315-.357.482-.542C13.232 10.765 14 9.925 14 9c0-1.289-.713-2-2-2-1.123 0-1.764.49-1.945 1.403ZM11 17.6a.6.6 0 01.6-.6h.8a.6.6 0 01.6.6v.8a.6.6 0 01-.6.6h-.8a.6.6 0 01-.409-.16.6.6 0 01-.191-.44v-.8Z"
        fill="currentcolor"
      />
    </svg>
  );
};

IconQuestionMarkCircleFull.displayName = "IconQuestionMarkCircleFull";
